var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card can-go-dark",
      staticStyle: { "margin-top": "10px", "border-radius": "5px" }
    },
    [
      _c(
        "div",
        { staticClass: "card-content", staticStyle: { padding: "10px" } },
        [
          _c("div", { staticClass: "content" }, [
            _vm.appInfoVisible
              ? _c(
                  "div",
                  [
                    _c("b-button", {
                      staticStyle: {
                        float: "right",
                        "margin-top": "-1px",
                        "border-radius": "7px"
                      },
                      attrs: {
                        type: "is-light",
                        pack: "fas",
                        "icon-left": "chevron-circle-down",
                        size: "is-small"
                      },
                      on: { click: _vm.toggleVisibility }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { color: "#999" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("appInfo.Version")) +
                            " " +
                            _vm._s(_vm.version) +
                            "\n          "
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: "/faq/changelog" } },
                          [
                            !_vm.userHasSeenCurrentVersion
                              ? _c(
                                  "b-tag",
                                  {
                                    attrs: {
                                      type: "is-light is-rounded",
                                      rounded: ""
                                    }
                                  },
                                  [_vm._v("\n              New!\n            ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: { float: "right", "margin-right": "10px" }
                      },
                      [
                        _c("router-link", { attrs: { to: "/faq/changelog" } }, [
                          _vm._v("\n            Changelog\n          ")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticStyle: { "margin-top": "0.5em" } }),
                    _vm._v(" "),
                    _c(
                      "b-carousel",
                      {
                        attrs: {
                          interval: 15000,
                          arrow: false,
                          "pause-info": false
                        },
                        model: {
                          value: _vm.shownSlide,
                          callback: function($$v) {
                            _vm.shownSlide = $$v
                          },
                          expression: "shownSlide"
                        }
                      },
                      _vm._l(_vm.carousels, function(carousel, i) {
                        return _c(
                          "b-carousel-item",
                          { key: i, staticStyle: { height: "150px" } },
                          [
                            _c(
                              "section",
                              { staticClass: "is-medium is-white" },
                              [
                                carousel.type == "html"
                                  ? _c(
                                      "div",
                                      { staticClass: "has-text-centered" },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(carousel.html)
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                carousel.type == "poll"
                                  ? _c(
                                      "div",
                                      { staticClass: "has-text-centered" },
                                      [
                                        !_vm.votedInPoll
                                          ? _c(
                                              "div",
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        carousel.pollPrompt
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  carousel.pollOptions,
                                                  function(option, j) {
                                                    return _c(
                                                      "b-button",
                                                      {
                                                        key: j,
                                                        attrs: {
                                                          type: "is-primary",
                                                          size: "is-small",
                                                          outlined: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.submitPollResponse(
                                                              carousel.pollTitle,
                                                              option,
                                                              i
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(option) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _c("div", [
                                              _c("p", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      carousel.voteMessage
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("b-button", {
                      staticStyle: {
                        float: "right",
                        "margin-top": "-1px",
                        "border-radius": "7px"
                      },
                      attrs: {
                        type: "is-light",
                        pack: "fas",
                        "icon-left": "chevron-circle-up",
                        size: "is-small"
                      },
                      on: { click: _vm.toggleVisibility }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { color: "#999" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("appInfo.Version")) +
                            " " +
                            _vm._s(_vm.version) +
                            "\n          "
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: "/faq/changelog" } },
                          [
                            !_vm.userHasSeenCurrentVersion
                              ? _c(
                                  "b-tag",
                                  {
                                    attrs: {
                                      type: "is-light is-rounded",
                                      rounded: ""
                                    }
                                  },
                                  [_vm._v("\n              New!\n            ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: { float: "right", "margin-right": "10px" }
                      },
                      [
                        _c("router-link", { attrs: { to: "/faq/changelog" } }, [
                          _vm._v("\n            Changelog\n          ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }